/* eslint-disable */

import { Switch } from "antd";
import moment from "moment";
import { FaEye } from "react-icons/fa";
import { URL_LANDING } from "../../../services/api/config";
import { Table } from 'antd';
export const columnsData = (
  { handleChangeStatus, openChangePosition, navigate },
  pageMenu
) => {
  return [
    {
      title: "Tiêu đề",
      dataIndex: "name",
      key: "name",
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
              cursor: pageMenu.details ? "pointer" : "unset",
            }}
            onClick={() => pageMenu.details && navigate(`/blogs/${record._id}`)}
          >
            {text}
          </div>
        );
      },
    },

    {
      title: "Người tạo",
      dataIndex: "created_by_user_info",
      key: "created_by_user_info",
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)" }}>
            {record?.created_by_user_info?.name}
          </div>
        );
      },
    },
    {
      title: "Người cập nhật cuối",
      dataIndex: "updated_by_user_info",
      key: "updated_by_user_info",
      render: (text, record, index) => {
        return (
          <div style={{ color: "rgb(56, 114, 174)" }}>
            {record?.updated_by_user_info?.name}
          </div>
        );
      },
    },
    {
      title: "Ngày tạo",
      dataIndex: "role",
      key: "role",
      render: (text, record, index) => {
        return (
          <div>{moment(record.created_at).format("YYYY-MM-DD HH:mm:ss")}</div>
        );
      },
    },
    {
      title: "Vị trí",
      dataIndex: "position",
      key: "position",
      render: (text, record, index) => {
        return (
          <div
            style={{
              color: "rgb(56, 114, 174)",
              fontWeight: "bold",
              cursor: pageMenu.details ? "pointer" : "unset",
            }}
            onClick={() => pageMenu.details && openChangePosition(record)}
          >
            {text}
          </div>
        );
      },
    },

    {
      title: "Trạng thái hoạt động",
      dataIndex: "status",
      key: "status ",
      render: (text, record, index) => {
        return (
          <Switch
            checked={text === "ACTIVE" ? true : false}
            disabled={!pageMenu.update}
            onChange={(e) => pageMenu.update && handleChangeStatus(e, record)}
          />
        );
      },
    },

    {
      title: "Preview",
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (text, record, index) => {
        return (
          <a href={`${URL_LANDING}/blogs/${record?.url_path}`} target="_blank">
            <FaEye size={24} style={{ cursor: "pointer" }} />
          </a>
        );
      },
    },
  ];
};
